import Tooltip from "./Tooltip";
import settings from "./settings";
import dic from "./dic";
import "./calendar";

export default class {

    /**
     * constructor
     * @param elem
     * @param _Tooltip
     * @returns {*}
     */
    constructor(elem, _Tooltip = Tooltip) {

        this.receiptObj = $(elem);

        this._Tooltip = Tooltip;
        this.tooltip = [];

        this.updateShopList();
        this.enableChangeStoreName();
        this.enableCalendar();
        this.enableTooltip();
        this.createChangeReceiptEvent();
        this.createChangeReceiptPriceEvent();
        this.enableOnlyNumInput();

        this.EVENT = {
            CHANGE_RECEIPT: "change_receipt",
            CHANGE_RECEIPT_PRICE: "change_receipt_price"
        };
    }

    get html() {
        return this.receiptObj.html();
    }

    get obj() {
        return this.receiptObj;
    }

    /**
     * CHANGE_RECEIPTイベントの有効化
     */
    createChangeReceiptEvent() {
        this.receiptObj.find("input,select,textarea").on("change keyup blur", (e) => {
            this.obj.trigger(this.EVENT.CHANGE_RECEIPT);
        });
    }

    /**
     * CHANGE_RECEIPT_PRICEイベントの有効化
     */
    createChangeReceiptPriceEvent() {
        let obj = this.receiptObj.find(settings.selector.price);
        obj.on("change keyup blur", (e) => {
            obj.trigger(this.EVENT.CHANGE_RECEIPT_PRICE);
        })
    }

    enableChangeStoreName() {
        let $shoplist = this.receiptObj.find(settings.selector.shopList);
        let $target1 = this.receiptObj.find(settings.selector.hiddenStoreName);
        let $target2 = this.receiptObj.find(settings.selector.hiddenStoreId);

        $shoplist.on("change", (e) => {
            $target1.val(settings.shopList[$shoplist.val()]);
            $target2.val($shoplist.val());
        });
    }

    /**
     * 店舗リストの挿入
     */
    updateShopList() {
        let shopList = settings.shopList;
        let $target = this.receiptObj.find(settings.selector.shopList);

        $.each(shopList, (shopId, shopName) => {
            $target.append(`<option value="${shopId}">${shopName}</option>`);
        });
    }

    /**
     * datepickerの有効化メソッド
     */
    enableCalendar() {
        this.receiptObj.find(settings.selector.date).datepicker($.datepicker.regional["ja"]);
    }

    /**
     * 数値以外キー入力の無効化
     */
    enableOnlyNumInput() {
        this.receiptObj.find(".register-no,.receipt-no,.price").numeric({decimal: false, negative: false});
    }

    /**
     * ツールチップの有効化
     */
    enableTooltip() {
        this.tooltip[0] = new this._Tooltip(this.receiptObj.find(".shoplist"), settings.templates[`tooltip2`]);
        this.tooltip[1] = new this._Tooltip(this.receiptObj.find(".register-no"), settings.templates[`tooltip3`]);
        this.tooltip[2] = new this._Tooltip(this.receiptObj.find(".receipt-no"), settings.templates[`tooltip4`]);
        this.tooltip[3] = new this._Tooltip(this.receiptObj.find(".price"), settings.templates[`tooltip5`]);
    }

    /**
     * エレメントをアニメーションで透明に
     */
    hidden() {
        this.obj.animate({opacity: 0}, "fast", "swing", () => {
            this.obj.css({display: "none"});
        });
    }

    /**
     * エレメントをアニメーションで表示
     */
    show() {
        this.obj.css({display: "block", opacity: 0});
        this.obj.animate({opacity: 1}, "fast");
    }

    /**
     * エレメント削除
     */
    clearAllValues() {
        this.obj.find("input,select,textarea").val("");
    }

    /**
     * 削除ボタンを非表示
     */
    hiddenRemoveButton() {
        this.obj.find(settings.selector.receiptRemove).css({"display": "none"});
    }

    /**
     * 削除ボタンを表示
     */
    showRemoveButton() {
        this.obj.find(settings.selector.receiptRemove).css({"display": "inline"});
    }

    /**
     * price欄更新時のツールチップ無効化
     */
    disableTooltip() {
        this.tooltip[3].isEnable = false;
    }

    /**
     * いずれかの項目に値があるかを返す
     */
    get isHasAnyValue() {
        let hasValue = false;

        this.obj.find("input,select,textarea").each((index, elem) => {
            let $elem = $(elem);
            if ($elem.val() !== "") {
                hasValue = true;
                return false;
            }
        });

        return hasValue;
    }

    /**
     * 瞬時にhidden（初期状態用0
     */
    quickHidden() {
        this.obj.css({display: "none"});
    }

    /**
     * 入力値のクリア
     */
    clearInputs() {
        this.obj.find("input,textarea,select").each((index, elem) => {
            let $elem = $(elem);
            $elem.val("");
        });
    }

    /**
     * 表示中かどうか確認
     */
    get isVisible() {
        let currentDisplay = this.obj.css("display");

        return currentDisplay !== "none";
    }

    /**
     * 全フォーム値の配列を返す
     * @returns {Array}
     */
    get allValuesArray() {
        let result = [];
        this.obj.find("input, select, textarea").each((index, elem) => {
            let $elem = $(elem);
            result.push($elem.val());
        });
        return result;
    }

    /**
     * 全フォームぶんの配列を設定
     * @param allValArray
     */
    setAllValues(allValArray) {
        this.obj.find("input, select, textarea").each((index, elem) => {
            let $elem = $(elem);
            $elem.val(allValArray[index]);
        });
    }
}
